/** Panel definitions (id, title, help key, minimum size, content). */
import { Viewport } from '../view/Viewport';
import { AnalysisPanel } from './panels/AnalysisPanel';
import { CalibrationPanel } from './panels/CalibrationPanel';
import { DisplayPanel } from './panels/DisplayPanel';
import { ExportPanel } from './panels/ExportPanel';
import { HelpPanel } from './panels/HelpPanel';
import { InspectorPanel } from './panels/InspectorPanel';
import { MetricsPanel } from './panels/MetricsPanel';
import { PhotometryPanel } from './panels/PhotometryPanel';
import { ProfilePanel } from './panels/ProfilePanel';
import { RoiPanel } from './panels/RoiPanel';
import { SourcesPanel } from './panels/SourcesPanel';
import type { PanelDef } from './WindowManager';

export const PANELS: PanelDef[] = [
  { id: 'image', title: 'Image', help: 'panel.image', minW: 240, minH: 180, render: () => <Viewport /> },
  { id: 'profile', title: 'Line profile', help: 'panel.profile', minW: 320, minH: 160, render: () => <ProfilePanel /> },
  { id: 'sources', title: 'Sources', help: 'panel.sources', minW: 240, minH: 120, render: () => <SourcesPanel /> },
  { id: 'photometry', title: 'Photometry', help: 'panel.photometry', minW: 240, minH: 120, render: () => <PhotometryPanel /> },
  { id: 'display', title: 'Display', help: 'panel.display', minW: 240, minH: 120, render: () => <DisplayPanel /> },
  { id: 'metrics', title: 'Metrics', help: 'panel.metrics', minW: 240, minH: 120, render: () => <MetricsPanel /> },
  { id: 'rois', title: 'ROIs', help: 'panel.rois', minW: 240, minH: 100, render: () => <RoiPanel /> },
  { id: 'inspector', title: 'Pixel inspector', help: 'panel.inspector', minW: 220, minH: 100, render: () => <InspectorPanel /> },
  { id: 'calibration', title: 'Calibration', help: 'panel.calibration', minW: 300, minH: 160, render: () => <CalibrationPanel /> },
  { id: 'analysis', title: 'Analysis', help: 'panel.analysis', minW: 360, minH: 200, render: () => <AnalysisPanel /> },
  { id: 'export', title: 'Export', help: 'panel.export', minW: 280, minH: 160, render: () => <ExportPanel /> },
  { id: 'help', title: 'Help', help: 'panel.help', minW: 320, minH: 200, render: () => <HelpPanel /> },
];

export const PANEL_TITLES: Record<string, string> = Object.fromEntries(PANELS.map((p) => [p.id, p.title]));
